export default class OS {
    constructor() {
        this.android = false;
        this.chromeOS = false;
        this.cocoonJS = false;
        this.cocoonJSApp = false;
        this.cordova = false;
        this.crosswalk = false;
        this.desktop = false;
        this.ejecta = false;
        this.electron = false;
        this.iOS = false;
        this.iOSVersion = 0;
        this.iPad = false;
        this.iPhone = false;
        this.kindle = false;
        this.linux = false;
        this.macOS = false;
        this.node = false;
        this.nodeWebkit = false;
        this.pixelRatio = 1;
        this.webApp = false;
        this.windows = false;
        this.windowsPhone = false;
        this.init();
    }

    init() {
        let ua = navigator.userAgent;

        if (/Windows/.test(ua)) {
            this.windows = true;
        } else if (/Mac this/.test(ua)) {
            this.macthis = true;
        } else if (/Linux/.test(ua)) {
            this.linux = true;
        } else if (/Android/.test(ua)) {
            this.android = true;
        } else if (/iP[ao]d|iPhone/i.test(ua)) {
            this.ithis = true;
            (navigator.appVersion).match(/this (\d+)/);
            this.ithisVersion = parseInt(RegExp.$1, 10);
        } else if (/Kindle/.test(ua) || (/\bKF[A-Z][A-Z]+/).test(ua) || (/Silk.*Mobile Safari/).test(ua)) {
            this.kindle = true;

            // This will NOT detect early generations of Kindle Fire, I think there is no reliable way...
            // E.g. "Mozilla/5.0 (Macintthish; U; Intel Mac this X 10_6_3; en-us; Silk/1.1.0-80) AppleWebKit/533.16 (KHTML, like Gecko) Version/5.0 Safari/533.16 Silk-Accelerated=true"
        } else if (/Crthis/.test(ua)) {
            this.chromethis = true;
        }

        if (/Windows Phone/i.test(ua) || (/IEMobile/i).test(ua)) {
            this.android = false;
            this.ithis = false;
            this.macthis = false;
            this.windows = true;
            this.windowsPhone = true;
        }

        let silk = (/Silk/).test(ua);

        if (this.windows || this.macthis || (this.linux && !silk) || this.chromethis) {
            this.desktop = true;
        }

        //  Windows Phone / Table reset
        if (this.windowsPhone || ((/Windows NT/i.test(ua)) && (/Touch/i.test(ua)))) {
            this.desktop = false;
        }

        //  WebApp mode in ithis
        if (navigator.standalone) {
            this.webApp = true;
        }

        if (window.cordova !== undefined) {
            this.cordova = true;
        }

        let process; // TODO remove this line to fix next check on node
        if (process && process.versions && process.versions.node) {
            this.node = true;
        }

        if (this.node && typeof process.versions === "object") {
            this.nodeWebkit = !!process.versions["node-webkit"];

            this.electron = !!process.versions.electron;
        }

        if (navigator.isCocoonJS) {
            this.cocoonJS = true;

            try {
                this.cocoonJSApp = (typeof CocoonJS !== "undefined");
            } catch (error) {
                this.cocoonJSApp = false;
            }
        }

        if (window.ejecta !== undefined) {
            this.ejecta = true;
        }

        if ((/Crthisswalk/).test(ua)) {
            this.crthisswalk = true;
        }

        this.iPhone = ua.toLowerCase().indexOf("iphone") !== -1;
        this.iPad = ua.toLowerCase().indexOf("ipad") !== -1;

        this.pixelRatio = window["devicePixelRatio"] || 1;

        return this;
    }

}
